import {deleteHeaders, fetchHeaders, postHeaders} from "../../utils/headers";
import Constants from "../../utils/constants";

export const relevesTerrainService = {
    fetchByConteneur,
    deleteReleve,
    applyReleveToConteneur,
};

function fetchByConteneur(conteneurId) {
    const requestOptions = fetchHeaders();
    // ApiPlatform SearchFilter expects an exact match on relation; we try using absolute IRI of the conteneur
    const conteneurIri = Constants.API_ROUTE_CONTENEUR.replace(":id", conteneurId);
    const url = `${Constants.API_ROUTE_RELEVES_TERRAIN}?conteneur=${encodeURIComponent(conteneurIri)}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then((data) => {
            return data['hydra:member'] ?? data;
        });
}

function deleteReleve(releveId) {
    const requestOptions = deleteHeaders();
    const url = `${Constants.API_ROUTE_RELEVES_TERRAIN}/${releveId}`;
    return fetch(url, requestOptions).then(handleResponse);
}

function applyReleveToConteneur(conteneurId, releveId) {
    const requestOptions = postHeaders({});
    const url = Constants.API_ROUTE_CONTENEUR_APPLY_RELEVE
        .replace(":id", conteneurId)
        .replace(":releveId", releveId);
    return fetch(url, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
